export default {
  title: "Myeuroservice",
  version: "1.1.2"
};
